import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'

import Filter from './Filter'
import StatisticData from './StatisticData'
import { ContentBlock, ContentBlockLoading, ExpandableBlocks } from 'components/ContentBlock'
import { useStatisticsData } from '../helpers'
import { initStatisticsData, getStatisticsData } from '../../gql/getLoyaltyCardStatistics'

const Loyaltycards = () => {
	const { getStatistics, data, loading, called } = useStatisticsData({
		getQuery: getStatisticsData,
		initQuery: initStatisticsData
	})

	const [expandedId, setExpandedId] = useState(null)
	const [showUsersCol, setShowUsersCol] = useState()
	const [t] = useTranslation()

	const handleFilter = params => {
		getStatistics({
			variables: { params }
		})
		setExpandedId('1')
	}

	return(
		<ExpandableBlocks expandedId={expandedId} onExpand={setExpandedId}>
			<ContentBlock
				blockId='0'
				startExpanded
				label={t('common.strings.settings')}
			>
				<Filter
					onFilter={handleFilter}
					showUsersCol={showUsersCol}
					setShowUsersCol={setShowUsersCol}
				/>
			</ContentBlock>
			{called &&
			<ContentBlockLoading
				alwaysExpanded
				isLoading={loading}
				topBorder
			>
				<StatisticData data={data} showUsersCol={showUsersCol} />
			</ContentBlockLoading>
			}
		</ExpandableBlocks>
	)
}

export default Loyaltycards
